import { GA_MEASUREMENT_ID } from 'constants/env';
import { reaction } from 'mobx';

import type { Session } from 'stores/session';

/**
 * @description
 * Keep the GA4 user_id in sync with the logged-in Pace account, following
 * https://developers.google.com/analytics/devguides/collection/ga4/user-id
 * - the internal account id only, never email or name (it must not identify the person to a third party)
 * - null on logout, never '' or 'null'
 * - a configuration parameter, never an event parameter or custom dimension
 *
 * Set through config on the Pace tag instead of gtag('set'): 'set' applies to every Google tag
 * on the page, and organizer GA properties are loaded on registration pages (RaceTracking).
 *
 * The store is passed in instead of imported: importing 'stores' from here changes the module
 * load order in Main.tsx and breaks the stores <-> utils import cycle.
 */
export function syncAnalyticsUserId(sessionStore: Session) {
  return reaction(
    () => sessionStore.session.user?.id ?? null,
    (id) => {
      try {
        window.gtag?.('config', GA_MEASUREMENT_ID, {
          user_id: id ? String(id) : null,
          send_page_view: false,
        });
      } catch (e) {
        console.error(e);
      }
    },
    { fireImmediately: true },
  );
}
